import { CompanyFinancialDayForm } from "modules/company";
import { DepositTypesForm, IncomeTypeList } from "modules/finances";
import { useRouter } from "next/router";
import React from "react";
import { CompanyFinancesLayout } from "./_layout";

const FinancesSettingsPage = () => {
  const companySlug = useRouter().query.company as string;

  return (
    <CompanyFinancesLayout>
      <CompanyFinancialDayForm companySlug={companySlug} />

      <DepositTypesForm companySlug={companySlug} htmlId="deposit-types" />
      <IncomeTypeList companySlug={companySlug} />
    </CompanyFinancesLayout>
  );
};

export default FinancesSettingsPage;
